<template>
  <div>
    <section class="app-section" id="patientAdd">
      <div>
        <Icon type="ios-contact" />&nbsp;基本信息
      </div>
      <Card style="margin-top:10px;">
        <Form ref="formValidates" :model="form" :rules="rules" :label-width="80">
          <FormItem label="姓名" prop="name">
            <Input v-model.trim="form.name" :maxlength="10" placeholder="请填写姓名" :size="formSize"></Input>
          </FormItem>
          <FormItem label="身份证号" prop="id_card">
            <Input
              v-model.trim="form.id_card"
              placeholder="请填写身份证号"
              @on-blur="onIdCardBlur()"
              :size="formSize"
            ></Input>
          </FormItem>
          <FormItem label="性别" prop="gender">
            <Select
              v-model="form.gender"
              placeholder="请选择性别"
              :size="formSize"
              :not-found-text="'请选择性别'"
            >
              <Option
                v-for="(item,index) in sexList"
                :value="item.value"
                :key="index"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="年龄" prop="age">
            <Input v-model.trim="form.age" placeholder="请填写年龄" :size="formSize"></Input>
          </FormItem>

          <FormItem label="联系方式" prop="phone">
            <Input v-model.trim="form.phone" placeholder="请填写联系方式" :size="formSize"></Input>
          </FormItem>
          <FormItem label="出生日期" prop="birthday">
            <DatePicker
              :value="form.birthday"
              type="date"
              format="yyyy-MM-dd"
              confirm
              placeholder="请选择出生日期"
              style="width: 100%"
              @on-change="handleDate"
            ></DatePicker>
          </FormItem>
          <FormItem label="体重(kg)" prop="weight">
            <Input v-model.trim="form.weight" placeholder="请填写体重" :size="formSize"></Input>
          </FormItem>

          <FormItem label="诊断" prop="diagnosis">
            <Select
              clearable
              ref="serviceStatusClear"
              v-model="form.diagnosis"
              filterable
              remote
              :remote-method="onDiagnosisSearch"
              :loading="loadingDiagnosis"
              placeholder="输入诊断名称搜索"
              :size="formSize"
              @on-query-change="queryChange"
            >
              <Option
                v-for="(i, index) in diagnosisLists"
                :value="i.diagnosis_name"
                :key="'dia_' + index"
              >{{i.diagnosis_name}}</Option>
            </Select>
          </FormItem>

          <FormItem label="其他诊断" prop="other_diagnosis">
            <Select
              multiple
              :max-tag-count="2"
              v-model="form.other_diagnosis"
              filterable
              remote
              :remote-method="onDiagnosisSearchOther"
              :loading="loadingDiagnosisOther"
              placeholder="输入诊断名称搜索"
              :size="formSize"
            >
              <Option
                v-for="(i, index) in diagnosisListsOther"
                :value="i.diagnosis_name"
                :key="'dia_' + index"
              >{{i.diagnosis_name}}</Option>
            </Select>
          </FormItem>

          <FormItem label="入院时间" prop="inHosTime">
            <DatePicker confirm placeholder="请选择入院时间" style="width: 100%" @on-change="handleDate1"></DatePicker>
          </FormItem>
          <FormItem label="就诊卡号" prop="medicalCard">
            <Input v-model.trim="form.medicalCard" placeholder="请填写就诊卡号" :size="formSize"></Input>
          </FormItem>
          <FormItem label="就诊卡类型" prop="medicalCardName">
            <Select v-model="medicalCardName" :size="formSize" style="width: 100%">
              <Option
                v-for="item in cardList"
                :value="item.alias"
                :key="item.value"
              >{{ item.alias }}</Option>
            </Select>
          </FormItem>
          <!-- <FormItem label="责任医生工号（主治）" prop="chargeDoctorCode">
            <Input
              v-model.trim="form.chargeDoctorCode"
              :maxlength="20"
              placeholder="请填写责任医生工号（主治）"
              :size="formSize"
            ></Input>
          </FormItem>-->

          <FormItem label="责任医生（主治）" prop="chargeDoctorName">
            <Select
              v-model="form.chargeDoctorName"
              filterable
              remote
              :remote-method="onDoctorSearch"
              :loading="loadingDoctor"
              placeholder="输入责任医生姓名搜索"
              :size="formSize"
            >
              <Option
                v-for="(i, index) in doctors"
                :value="i.name"
                :key="'doctor_' + index"
              >{{showLabel(i)}}</Option>
            </Select>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input v-model.trim="form.remark" placeholder="请填写备注" :size="formSize"></Input>
          </FormItem>
          <FormItem label="亲属联系方式" prop="relatives_phone">
            <Input v-model.trim="form.relatives_phone" placeholder="请填写亲属联系方式" :size="formSize"></Input>
          </FormItem>
          <FormItem label="亲属联系方式2" prop="relatives_phone2">
            <Input v-model.trim="form.relatives_phone2" placeholder="请填写亲属联系方式2" :size="formSize"></Input>
          </FormItem>
          <FormItem label="住院号" prop="in_hospital_no">
            <Input v-model.trim="form.in_hospital_no" placeholder="请填写住院号" :size="formSize"></Input>
          </FormItem>
          <FormItem label="放疗号" prop="radiotherapy_no">
            <Input v-model.trim="form.radiotherapy_no" placeholder="请填写放疗号" :size="formSize"></Input>
          </FormItem>
          <FormItem label="地址" prop="provinceName" style="width:66%;">
            <el-cascader
              size="large"
              :options="options"
              v-model="form.provinceName"
              @change="handleChange"
              style="width:40%;margin-right:10px"
            ></el-cascader>
            <FormItem prop="address" style="margin-left:10px">
              <el-input v-model.trim="form.address" placeholder="请填写具体地址" :size="formSize"></el-input>
            </FormItem>
          </FormItem>
        </Form>
      </Card>

      <div style="text-align:center;margin-top:16px;">
        <Button :size="formSize" @click="closePage()">取消</Button>
        <Button
          type="primary"
          style="margin-left:20px"
          :size="formSize"
          @click="submitAndPerfect()"
        >保存并完善信息</Button>
        <Button
          type="primary"
          style="margin-left:20px"
          :size="formSize"
          @click="submitAndNext()"
        >保存并继续添加</Button>
      </div>
    </section>
  </div>
</template>

<script>
import {
  addConfirmedPerson,
  getDiagnosis,
  getConfig,
  getDoctors,
} from '../../api/person'
import route from '../../route/config'
import Vue from 'vue'
import { Message, MessageBox } from 'element-ui'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'

export default {
  name: 'patientAdd',
  props: ['info'],
  data: function () {
    return {
      form: {
        provinceName: '',
        address: '',
        name: '',
        gender: '',
        age: '',
        id_card: '',
        phone: '',
        birthday: '',
        origin: '',
        questionaire: '',
        weight: '',
        diagnosis: '',
        other_diagnosis: '',
        inHosTime: '',
        medicalCard: '',
        medicalCardType: '',
        chargeDoctorCode: '',
        chargeDoctorName: '',
        // chargeDoctorUsername: '',
        remark: '',
      },
      rules: {
        name: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
        id_card: [
          { required: true, message: '请填写身份证号', trigger: 'blur' },
          {
            type: 'string',
            min: 18,
            max: 18,
            message: '请填写合法身份证号',
            trigger: 'blur',
          },
        ],
        diagnosis: [{ required: true, message: '请填写诊断', trigger: 'blur' }],
        phone: [
          { required: true, message: '请填写本人电话', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: ['blur', 'change'],
          },
        ],
        origin: [
          { required: true, message: '请选择筛查来源', trigger: 'change' },
        ],
        provinceName: [
          {
            type: 'array',
            required: true,
            message: '请选择地址',
            trigger: 'blur',
          },
        ],
        // address: [
        //   { required: true, message: '请填写具体地址', trigger: 'blur' },
        // ],
      },
      formSize: 'default',
      flag: '',
      sexList: [
        // {
        //   value: '',
        //   label: '全部',
        // },
        {
          value: '1',
          label: '男',
        },
        {
          value: '0',
          label: '女',
        },
      ],
      diagnosisLists: [],
      diagnosisListsOther: [],
      rangeNumber: 10,
      diagnosis_code: '',
      other_diagnosis_code: [],
      options: regionData,
      region: [],
      cardList: [],
      doctors: [],
      loadingDoctor: false,
      loadingDiagnosis: false,
      loadingDiagnosisOther: false,
      medicalCardName: '',
    }
  },
  computed: {},
  methods: {
    showLabel: function (i) {
      let res
      if (i.employee_id) {
        res = i.name + '(' + i.employee_id + ')'
      } else {
        res = i.name
      }
      return res
    },
    onIdCardBlur: function () {
      // 身份证输入框失去焦点
      const id_card_no = this.form.id_card
      if (id_card_no && id_card_no.length === 18) {
        const birth_year = Number(id_card_no.substring(6, 10))
        const birth_day =
          id_card_no.substring(6, 10) +
          '-' +
          id_card_no.substring(10, 12) +
          '-' +
          id_card_no.substring(12, 14)
        const gender = Number(id_card_no.substring(16, 17)) % 2

        this.form.gender = gender.toString()
        this.form.age = new Date().getFullYear() - birth_year
        this.form.birthday = birth_day
        // console.log(birth_day)
      }
    },
    closePage: function () {
      // 关闭选项卡
      let allSelectedKeys = this.$store.getters.allSelectedKeys,
        lastIndex
      allSelectedKeys.forEach((pane, i) => {
        if (pane.key === 'slowPatient') {
          lastIndex = i - 1
        }
      })
      if (allSelectedKeys.length) {
        if (lastIndex >= 0) {
          this.$store.commit('setActiveKey', allSelectedKeys[lastIndex].key)
        } else {
          this.$store.commit('setActiveKey', allSelectedKeys[0].key)
        }
      }
      this.$store.commit('setAllSelectedKeys', {
        type: 'delete',
        name: 'slowPatient',
        title: '新增慢病患者',
        key: 'slowPatient',
      })
    },
    submitAndPerfect: function () {
      // 保存并完善信息
      this.flag = 'submitAndPerfect'
      this.submitInfo()
    },
    submitAndNext: function () {
      // 保存并继续添加
      var self = this
      self.flag = 'submitAndNext'
      self.submitInfo()
    },
    submitInfo: function () {
      // 提交
      var self = this
      self.other_diagnosis_code = []
      if (self.form.other_diagnosis && self.form.other_diagnosis.length > 0) {
        self.diagnosisListsOther.forEach((v) => {
          self.form.other_diagnosis.forEach((j, index) => {
            if (j == v.diagnosis_name) {
              if (self.other_diagnosis_code.includes(v.icd_diagnosis_code)) {
              } else {
                self.other_diagnosis_code.push(v.icd_diagnosis_code)
              }
            }
          })
        })
      }
      if (self.medicalCardName) {
        let card = self.medicalCardName
        self.cardList.forEach((v) => {
          if (v.alias == card) {
            self.form.medicalCardType = v.value
          }
        })
      }
      console.log(self.form, self.other_diagnosis_code)
      let obj = {}
      self.$refs.formValidates.validate((valid) => {
        if (valid) {
          var form = self.form
          obj = {
            name: form.name,
            gender: form.gender,
            age: form.age,
            id_card: form.id_card,
            phone: form.phone,
            birthday: form.birthday,
            weight: form.weight,
            diagnosis: form.diagnosis,
            diagnosis_code: self.diagnosis_code,
            other_diagnosis:
              form.other_diagnosis && form.other_diagnosis.length > 0
                ? form.other_diagnosis.join(',')
                : '',
            other_diagnosis_code: self.other_diagnosis_code.join(','),
            in_hos_time: form.inHosTime ? form.inHosTime + ' 00:00:00' : '',
            medical_card: form.medicalCard,
            medical_card_type: form.medicalCardType,
            charge_doctor_code: form.chargeDoctorCode,
            charge_doctor_name: form.chargeDoctorName,
            radiotherapy_no: form.radiotherapy_no,
            relatives_phone: form.relatives_phone,
            relatives_phone2: form.relatives_phone2,
            in_hospital_no: form.in_hospital_no,
            remark: form.remark,
            address: form.address,
            province: self.region[0],
            city: self.region[1],
            county: self.region[2],
          }

          if (self.info) {
            obj.filtrate_person_id = self.info.id
            obj.user_id = self.info.user_id
          }
          self.doPlan(obj)
        }
      })
    },
    doPlan: function (obj) {
      var self = this
      console.log(obj)
      self.$utils.loadingShow()
      addConfirmedPerson(obj).then((res) => {
        console.log(res)
        self.$utils.loadingHide()
        let info = res.data
        if (res.code === 0) {
          self.$Message.success('新增慢病患者成功')
          if (self.flag == 'submitAndPerfect') {
            self.$store.commit('setAllSelectedKeys', {
              type: 'add',
              name: 'medicalBasic',
              title: self.form.name + '—慢病信息',
              key: `medicalBasic?${info.id}`,
              extra: {
                user: info,
              },
            })
          } else {
            self.form = {
              name: '',
              gender: '',
              age: '',
              id_card: '',
              phone: '',
              birthday: '',
              weight: '',
              diagnosis: '',
              other_diagnosis: '',
              inHosTime: '',
              medicalCard: '',
              medicalCardType: '',
              chargeDoctorCode: '',
              chargeDoctorName: '',
              address: '',
              remark: '',
            }
            self.$refs.formValidates.resetFields()
          }
        } else if (res.code === 30009) {
          MessageBox.confirm(
            '已存在该慢病患者,为您直接跳转该慢病患者详情?',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true,
            }
          ).then(() => {
            self.$store.commit('setAllSelectedKeys', {
              type: 'add',
              name: 'medicalBasic',
              title: self.form.name + '—慢病信息',
              key: `medicalBasic?${info.id}`,
              extra: {
                user: info,
              },
            })
          })
        } else {
          self.$Message.warning(res.message)
        }
      })
    },

    handleDate: function (date) {
      console.log(date)
      this.form.birthday = date
    },
    handleDate1: function (date) {
      console.log(date)
      this.form.inHosTime = date
    },

    selectDiagnosis(val) {
      this.diagnosisLists.forEach((v) => {
        if (v.diagnosis_name == val) {
          this.diagnosis_code = v.icd_diagnosis_code
        }
      })
    },

    handleChange: function () {
      var arr = []
      for (let i = 0; i < this.form.provinceName.length; i++) {
        arr.push(CodeToText[this.form.provinceName[i]])
      }
      this.region = arr
    },
    getMedicalType: function () {
      let obj = {
        key: 'medical_card_type',
      }
      getConfig(obj).then((res) => {
        if (res.code === 0) {
          this.cardList = res.data
        } else {
          this.$Message.warning(res.message)
        }
      })
    },
    onDoctorSearch: function (query) {
      let newstr = query.split('(')
      let str = newstr[0]
      let chargeDoctorCode = newstr[1] ? newstr[1].split(')') : ''
      this.form.chargeDoctorCode = chargeDoctorCode[0] || ''
      // 接诊医生搜索
      this.loadingDoctor = true
      let params = {
        name: str,
      }
      getDoctors(params).then((res) => {
        this.loadingDoctor = false
        if (res.code === 0) {
          let ruslut = res.data
          this.doctors = ruslut
        } else {
          this.$Message.warning(res.message)
        }
      })
    },
    onDiagnosisSearch: function (query) {
      console.log(query)
      // 接诊医生搜索
      let obj = {
        page: 1,
        size: 100,
        name: query,
      }
      this.loadingDiagnosis = true
      getDiagnosis(obj).then((res) => {
        this.loadingDiagnosis = false
        if (res.code === 0) {
          this.diagnosisLists = res.data
        } else {
          this.$Message.warning(res.message)
        }
      })
    },

    onDiagnosisSearchOther: function (query) {
      console.log(query)
      // 接诊医生搜索
      let obj = {
        page: 1,
        size: 100,
        name: query,
      }
      this.loadingDiagnosisOther = true
      getDiagnosis(obj).then((res) => {
        this.loadingDiagnosisOther = false
        if (res.code === 0) {
          this.diagnosisListsOther = res.data
        } else {
          this.$Message.warning(res.message)
        }
      })
    },
    queryChange(query) {
      if (query == '') {
        this.$refs.serviceStatusClear.clearSingleSelect() //清除下拉框功能
      }
    },
  },
  mounted: function () {
    console.log(this.info)
    if (this.info) {
      this.form = JSON.parse(JSON.stringify(this.info))
      var arr = []
      this.region = [this.form.province, this.form.city, this.form.county]
      if (this.form.province) {
        arr.push(TextToCode[this.form.province].code)
        console.log(TextToCode[this.form.province][this.form.city])
        if (!TextToCode[this.form.province][this.form.city]) {
          this.form.city = '市辖区'
        }
        arr.push(TextToCode[this.form.province][this.form.city].code)
        arr.push(
          TextToCode[this.form.province][this.form.city][this.form.county].code
        )
      }
      this.form.provinceName = arr
      if (this.info.other_diagnosis) {
        this.form.other_diagnosis = this.info.other_diagnosis.split(',')
      }
      if (this.info.gender) {
        this.form.gender = this.info.gender.toString()
      }
      if (this.form.id_card) {
        this.onIdCardBlur()
      }
    }
    // this.getDiagnosis()
    this.getMedicalType()
    this.onDiagnosisSearch('')
    this.onDiagnosisSearchOther('')
  },
}
</script>

<style lang="less" scoped>
@import '../../styles/common.less';

#patientAdd {
  background-color: @background-color;

  .ivu-form-item {
    display: inline-block;
    width: 33%;
    .el-cascader {
      .el-input input {
        line-height: 32px;
        height: 32px;
      }
    }
    .el-input input {
      line-height: 32px;
      height: 32px;
    }
  }
}
.diagnosis .el-input__inner {
  height: 32px;
  line-height: 32px;
}
</style>
